import React, { useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PlanMainContent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const historyRef = useRef({
    paths: [],
    pointer: -1,
    initialized: false,
  });

  const [canGoBack, setCanGoBack] = useState(false); // ✅ state for re-render

  useEffect(() => {
    const currentPath = location.pathname;
    const history = historyRef.current;

    if (!history.initialized) {
      history.paths.push(currentPath);
      history.pointer = 0;
      history.initialized = true;
      setCanGoBack(false); // 🔁 update state
      return;
    }

    const currentStored = history.paths[history.pointer];

    if (currentStored !== currentPath) {
      history.paths = history.paths.slice(0, history.pointer + 1);
      history.paths.push(currentPath);
      history.pointer++;

      setCanGoBack(history.pointer > 0); // 🔁 update state on change
    }
  }, [location.pathname]);

  const handleBack = () => {
    const history = historyRef.current;

    if (history.pointer > 0) {
      history.pointer--;
      const previousPath = history.paths[history.pointer];
      setCanGoBack(history.pointer > 0); // 🔁 update state on back
      if (previousPath) {
        navigate(previousPath);
      }
    }
  };

  return (
    <Box sx={{ flex: 1, py: "6px" }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={handleBack}
        variant="outlined"
        sx={{ mb: 2, position:"absolute", zIndex:"2" }}
        disabled={!canGoBack} // ✅ controlled by state
      >
        Back
      </Button>
      <Outlet />
    </Box>
  );
};

export default PlanMainContent;
